import { ScanIqCustomer } from '../../scan-iq-customer-management';
import { apiService } from '../../shared/services/apiService';
import { VerificationChannel } from '../constants/verificationChannel';

export type SendVerificationCodeResponse = {
  nextCallEpoch: number;
};

export type VerifyCodeParams = {
  to: string;
  code: string;
  targetId: number;
};

export type VerifyCodeConfig = {
  ignoreErrorCodes?: number[];
};

type ChallengeVerifyCodeResponse = {
  challengeParticipantId: number;
  scanIqCustomer: ScanIqCustomer;
};

export const twoFAService = {
  async sendVerificationCode(
    to: string,
    channel: VerificationChannel,
  ): Promise<SendVerificationCodeResponse> {
    const response = await apiService.post(
      'api/public/two-factor-authentication/verification-code',
      {
        to,
        channel,
      },
    );

    return response.data;
  },

  async verifyCodeForScanIq(
    params: VerifyCodeParams,
    config?: VerifyCodeConfig,
  ): Promise<ScanIqCustomer> {
    const { to, code, targetId } = params;

    const response = await apiService.post(
      'api/public/two-factor-authentication/verify-code',
      {
        to,
        code,
        entityId: targetId,
      },
      config,
    );

    return response.data;
  },

  async verifyCodeForChallenge(
    params: VerifyCodeParams,
    config?: VerifyCodeConfig,
  ): Promise<ChallengeVerifyCodeResponse> {
    const { to, code, targetId } = params;

    const response = await apiService.post(
      '/api/public/two-factor-authentication/challenge/verify-code',
      {
        to,
        code,
        challengeId: targetId,
      },
      config,
    );

    return response.data;
  },
};
